<template>
    <div>
        <!-- Input form -->
        <section class="w-full bg-blue-100">
            <div class="bg-white rounded-b-2xl">
                <div class="self-gutter">
                    <div class="self-gutter-y self-content-sm">
                        <ReportNavigation v-if="this.$route.path.startsWith(`/${$i18n.locale}/reports`)"/>
                        <h1 class="title-2xl">{{ $t('invoice_report.title') }}</h1>
                        <AlertSummary v-if="!generateReportOk" :main-text="$t('error.main_text')" :secondary-text="$t('error.secondary_text')" alert-classes="mt-24 e5-form-error-summary--error"/>

                        <div class="pt-24 self-hero-intro" :class="{ 'show-full-desc': showFullDesc }">
                            <p v-html="$t('invoice_report.desc')" ref="descContainer"></p>
                        </div>
<!-- REPORT FORM -->
                    <div class="pt-24 self-form-wrap">

                        <div class="w-full sm:w-5/12 self-form-wrap-item" :class="{'e5-error': !generateReportOk}">
                            <label class="self-form-item-label"
                                   for="title">{{ $t('reports.form.period') }}:</label>
                            <div class="relative">
                                <button ref="calendarButton" id="calendar" class="e5-input-calendar" :class="{'e5-error': !generateReportOk}"
                                        aria-haspopup="true" aria-expanded="false" @click="dropdown('calendarButton')">
                                    <span :class="{'text-alert': !generateReportOk}">
                                    {{
                                            InvoiceByDateRequest.invoicestartdate || InvoiceByDateRequest.invoiceenddate ? selectedDateRange : $t('reports.form.period_placeholder')
                                        }}</span>
                                </button>
                                <div class="e5-input-icon">
                                    <CalendarSVG/>
                                </div>
                                <DropDownCalendar v-model="selectedDateRange" @input="handleDateChange"/>
                            </div>
                            <a class="hover:text-blue-400 cursor-pointer" @click="quickSelectDates('currentMonth')">{{ $t('reports.form.current_month') }}</a> |
                            <a class="hover:text-blue-400 cursor-pointer" @click="quickSelectDates('lastMonth')">{{ $t('reports.form.last_month') }}</a> |
                            <a class="hover:text-blue-400 cursor-pointer" @click="quickSelectDates('currentYear')">{{ $t('reports.form.current_year') }}</a> |
                            <a class="hover:text-blue-400 cursor-pointer" @click="quickSelectDates('lastYear')">{{ $t('reports.form.last_year') }}</a>
                        </div>

                        <div class="w-full xs:w-1/2 sm:w-3/12 self-form-wrap-item">
                            <label class="self-form-item-label"
                                   for="invoice">{{ $t('reports.form.invoice_no') }}:</label>
                            <div class="relative">
                                <input type="text" id="invoice"
                                       :placeholder="invoiceNoPlaceholderText" name="invoice"
                                       class="e5-input" v-model="InvoiceByDateRequest.invoicenumber">
                            </div>
                        </div>

                        <div class="w-full xs:w-1/2 sm:w-4/12 self-form-wrap-item">
                            <label class="self-form-item-label" for="title">&nbsp;</label>
                            <div class="block">
                                <input class="e5-checkbox" type="checkbox" id="reisija" name="reisija" value=""
                                       v-model="showOnlyUnpaidInvoices" @click="togglePaymentStatus">
                                <label class="" for="reisija">
                                    {{ $t('reports.form.payment_status') }}
                                </label>
                            </div>
                        </div>
                        <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                            <label class="self-form-item-label"
                                   for="name">{{ $t('reports.form.passenger_name') }}:</label>
                            <div class="relative">
                                <input type="text" id="name" placeholder="" name="name"
                                       class="e5-input"
                                       v-model="InvoiceByDateRequest.passenger.name">
                            </div>
                        </div>

                        <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                            <label class="self-form-item-label"
                                   for="reference">{{ $t('reports.form.passenger_ref') }}:</label>
                            <div class="relative">
                                <input type="text" id="reference" placeholder="" name="reference"
                                       class="e5-input"
                                       v-model="InvoiceByDateRequest.passenger.reference">
                            </div>
                        </div>

                        <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                            <label class="self-form-item-label"
                                   for="customer">{{ $t('reports.form.customer_ref') }}:</label>
                            <div class="relative">
                                <input type="text" id="customer" placeholder="" name="customer"
                                       class="e5-input"
                                       v-model="InvoiceByDateRequest.booking.customerreference">
                            </div>
                        </div>

                        <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                            <label class="self-form-item-label"
                                   for="booked">{{ $t('reports.form.booked_by') }}:</label>
                            <div class="relative">
                                <input type="text" id="booked" placeholder="" name="booked"
                                       class="e5-input" v-model="InvoiceByDateRequest.booking.bookedbyname">
                            </div>
                        </div>

                        <!-- class="flex flex-wrap w-full max-h-0" -->
                        <div aria-labelledby="hiddenrow" class="flex flex-wrap w-full max-h-0 overflow-hidden">
                            <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="code">{{ $t('reports.form.project_code') }}:</label>
                                <div class="relative">
                                    <input type="text" id="code" placeholder="" name="code"
                                           class="e5-input" v-model="InvoiceByDateRequest.booking.projectcode">
                                </div>
                            </div>
                            <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="budget">{{ $t('reports.form.budget_code') }}:</label>
                                <div class="relative">
                                    <input type="text" id="budget" placeholder="" name="budget"
                                           class="e5-input" v-model="InvoiceByDateRequest.booking.budgetcode">
                                </div>
                            </div>

                            <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="account">{{ $t('reports.form.fin_account') }}:</label>
                                <div class="relative">
                                    <input type="text" id="account" placeholder="" name="account"
                                           class="e5-input" v-model="InvoiceByDateRequest.booking.finaccount">
                                </div>
                            </div>
                            <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="me">{{ $t('reports.form.me_number') }}:</label>
                                <div class="relative">
                                    <input type="text" id="me" placeholder="" name="me"
                                           class="e5-input"
                                           v-model="InvoiceByDateRequest.booking.menumber">
                                </div>
                            </div>
                        </div>

                        <div class="self-form-wrap-actions">
                            <div>
                                <button v-if="$store.state.invoiceExtraFields" ref="animateToggleButton"
                                        aria-expanded="false"
                                        id="hiddenrow" class="self-btn-plain"
                                        @click="animatetoggle('animateToggleButton')" data-toggle="animatetoggle">
                                    <span class="self-btn-plain__text" >{{ $t('reports.form.more_options') }}</span>
                                    <span class="self-btn-plain__icon self-moreinfo-icon"><IconArrowFrwardSVG/></span>
                                </button>
                            </div>

                            <div class="flex xs-down:justify-end xs-down:pt-24">
                                <button class="mr-24 self-btn-secondary hover:cursor-pointer"
                                   @click="clearAll">{{ $t('reports.form.clear_all') }}</button>

                                <button class="self-btn-primary" @click="generateOnClick(InvoiceByDateRequest)">
                                    {{ $t('reports.form.generate_report') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Not empty response -->
        <article v-if="InvoiceByDateResponce && requestSent">
        <section id="resultsTable" class="relative bg-blue-100 rounded-b-2xl self-gutter-y">
            <div class="self-gutter">
                <div class="self-content-sm">
                    <div class="self-table-info">
                        <div class="flex items-center sm-down:w-full sm-down:justify-between">
                            <span class="block text-base">{{ $t('reports.table.total') }}: <span
                                class="font-semibold whitespace-nowrap">{{
                                    formatSum(totalSum())
                                }}</span></span>

                            <div class="self-table-info-entries-count"></div>
                        </div>

                        <div class="flex items-center sm-down:w-full sm-down:justify-between sm-down:pt-16">
                            <div class="self-table-info-entries-select"></div>

                            <div class="relative inline-block">
                                <div class="relative inline-block ">
                                    <button ref="exportButton" class="self-btn-plain"
                                            id="export-report"
                                            aria-haspopup="true" aria-expanded="false"
                                            @click="dropdown('exportButton')">
                                        <span class="self-btn-plain__text">{{ $t('reports.table.export') }}</span>
                                        <span class="self-btn-plain__icon self-moreinfo-icon">
                                            <IconArrowFrwardSVG/>
                                        </span>
                                    </button>

                                    <div class="e5-dropdown e5-dropdown-xs" aria-labelledby="export-report">
                                        <div class="p-10">
                                            <a class="py-5 self-text-link hover:cursor-pointer" href="#" @click="download('.xlsx')">Excel
                                                (XLSX)</a>
                                            <a class="py-5 self-text-link hover:cursor-pointer" href="#" @click="download('.csv')">CSV</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table class="w-full self-table" v-if="InvoiceByDateResponce">
                        <thead>
                        <tr>
                            <th><span>{{ $t('reports.table.invoice_no') }}</span></th>
                            <th class="date"><span>{{ $t('reports.table.invoice_date') }}</span></th>
                            <th class="date"><span>{{ $t('reports.table.payment_due_date') }}</span></th>
                            <th class="self-table-price sum"><span>{{ $t('reports.table.invoice_sum') }}</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in InvoiceByDateResponce.invoicelist" :key="item.invoicenumber">
                            <td><a :href="item.invoiceurl" v-text="item.invoicenumber"
                                   @click.prevent="downloadInvoice(item.invoiceurl.split('/').slice(-1)[0], item.invoicenumber)"/></td>
                            <td>{{ formatDate(item.invoicedate) }}</td>
                            <td v-if="hasDatePassed(item.duedate) && item.paymentstatus === 'unpaid'"><span class="text-alert">{{ formatDate(item.duedate) }}</span></td>
                            <td v-else-if="item.paymentstatus === 'paid'"><span class="text-primary">{{ formatDate(item.duedate) }}</span></td>
                            <td v-else>{{ formatDate(item.duedate) }}</td>
                            <td class="self-table-price">{{ formatSum(item.invoicesuminclvat) }}</td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </section>
        </article>
            <!-- Empty response -->
        <article v-else>
        <section id="resultsTable" class="relative bg-blue-100 rounded-b-2xl self-gutter-y">
            <div class="self-gutter">
                <div class="self-content-sm">

                    <span class="block title-2xl pt-32 pb-[300px] text-black font-normal"
                        v-if="requestSent && responseReceived">{{ $t('reports.table.no_results') }}</span>
                    <span class="block title-2xl pt-32 pb-[300px] text-black font-normal" v-else-if="requestSent">
                        <span class="loading-animation">{{ $t('reports.table.searching') }}<span class="loading-dots">
                            <span class="dot">.</span>
                            <span class="dot">.</span>
                            <span class="dot">.</span>
                        </span></span></span>

                </div>
            </div>
        </section>
        </article>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { IInvoiceByDateRequest, IReportInvoiceByDateResponce } from '@/domain/IReport'
import { IPassenger } from '@/domain/IPassenger'
import { IBooking } from '@/domain/IBooking'
import store from '@/store'
import * as XLSX from 'xlsx'
import DropDownCalendar from '@/components/DropDownCalendar.vue'
import CalendarSVG from '@/assets/static/icons-src/icon-calendar.svg'
import ArrowRightSVG from '@/assets/static/icons-src/est-arrow-right.svg'
import ArrowLeftSVG from '@/assets/static/icons-src/est-arrow-left.svg'
import LogoIllustrationSVG from '@/assets/static/icons-src/logo-illustration.svg'
import IconArrowFrwardSVG from '@/assets/static/icons-src/icon-arrow-forward.svg'
import $ from 'jquery'
import UtilsMixin from '@/scripts/utils'
import moment from 'moment';
import AlertSummary from '@/components/AlertSummary.vue'
import ReportNavigation from '@/components/ReportNavigation.vue'
import i18n from '@/i18n'
@Component({
    components: {
        ReportNavigation,
        AlertSummary,
        DropDownCalendar,
        CalendarSVG,
        ArrowRightSVG,
        ArrowLeftSVG,
        LogoIllustrationSVG,
        IconArrowFrwardSVG
    },
    metaInfo: {
        title: 'Invoice report'
    },
    mixins: [UtilsMixin]
})
export default class Reports extends Vue {
    // Data properties
    selectedDateRange = ''
    showOnlyUnpaidInvoices = false
    requestSent = false
    generateReportOk = true
    private initExtraTable = true
    private extraTable = null
    responseReceived = false
    showFullDesc = false
    InvoiceByDateRequest: IInvoiceByDateRequest = {
        passenger: {
            passengerId: '',
            name: '',
            birthday: '',
            reference: ''
        } as unknown as IPassenger,
        invoicestartdate: '',
        invoiceenddate: '',
        invoicenumber: '',
        paymentstatus: 'all',
        booking: {
            bookingnumber: '',
            bookedbyname: '',
            customerreference: '',
            projectcode: '',
            employeenumber: '',
            finaccount: '',
            budgetcode: '',
            menumber: ''
        } as unknown as IBooking,
        customerid: store.state.customerId
    }

    // Computed property
    get InvoiceByDateResponce(): IReportInvoiceByDateResponce {
        return store.state.ReportInvoiceByDateResponce
    }

    get invoiceNoPlaceholderText(): string {
        return this.$t('reports.form.invoice_no_placeholder') as string;
    }

    // Methods

    handleDateChange() {
        const selectedDates = this.selectedDateRange
        if (selectedDates.split(' to ').length === 2) {
            this.generateReportOk = true
            this.InvoiceByDateRequest.invoicestartdate = selectedDates.split(' to ')[0]
            this.InvoiceByDateRequest.invoiceenddate = selectedDates.split(' to ')[1]
            // Format dates for the request
            this.InvoiceByDateRequest.invoicestartdate = this.InvoiceByDateRequest.invoicestartdate.replace(/\./g, '-')
            this.InvoiceByDateRequest.invoiceenddate = this.InvoiceByDateRequest.invoiceenddate.replace(/\./g, '-')

            const startParts = this.InvoiceByDateRequest.invoicestartdate.split('-')
            this.InvoiceByDateRequest.invoicestartdate = `${startParts[2]}-${startParts[1]}-${startParts[0]}`

            const endParts = this.InvoiceByDateRequest.invoiceenddate.split('-')
            this.InvoiceByDateRequest.invoiceenddate = `${endParts[2]}-${endParts[1]}-${endParts[0]}`

            this.selectedDateRange = this.selectedDateRange.replace('to', '—')
        }
    }

    quickSelectDates(range: string) {
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1
        let startDate: Date
        let endDate: Date
        switch (range) {
        case 'currentMonth':
            startDate = new Date(currentYear, currentMonth - 1, 1) // Start of the current month.
            endDate = new Date(currentYear, currentMonth, 0) // End of the current month.;
            break
        case 'lastMonth':
            if (currentMonth === 1) {
                startDate = new Date(currentYear - 1, 11, 1) // Start of December in the previous year.
                endDate = new Date(currentYear - 1, 12, 0) // End of December in the previous year.
            } else {
                startDate = new Date(currentYear, currentMonth - 2, 1) // Start of the previous month.
                endDate = new Date(currentYear, currentMonth - 1, 0) // End of the previous month.
            }
            break
        case 'currentYear':
            startDate = new Date(currentYear, 0, 1) // Start of the current year.
            endDate = new Date(currentYear, 12, 0) // End of the current year.
            break
        case 'lastYear':
            startDate = new Date(currentYear - 1, 0, 1) // Start of the current year.
            endDate = new Date(currentYear - 1, 12, 0) // End of the current year.
        }
        // Format the start and end dates as strings and set the selectedDateRange.
        const startDateStr = startDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).replaceAll('/', '.')
        const endDateStr = endDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).replaceAll('/', '.')

        this.selectedDateRange = `${startDateStr} to ${endDateStr}`
        this.handleDateChange()
    }

    togglePaymentStatus() {
        if (this.showOnlyUnpaidInvoices === true) {
            this.InvoiceByDateRequest.paymentstatus = 'all'
        } else {
            this.InvoiceByDateRequest.paymentstatus = 'unpaid'
        }
    }

    totalSum() {
        if (this.InvoiceByDateResponce) {
            return this.InvoiceByDateResponce.invoicelist.reduce(
                (total, item) => total + parseFloat(item.invoicesuminclvat),
                0
            )
        }
        return 0
    }

    hasDatePassed(date) {
        const currentDate = new Date() // Get the current date
        const givenDate = new Date(date) // Convert the given date string to a Date object

        // Set the time of both dates to 00:00:00
        currentDate.setHours(0, 0, 0, 0)
        givenDate.setHours(0, 0, 0, 0)
        return givenDate < currentDate
    }

    private createExtraTable () {
        this.destroyExtraTable()
        $.fn.dataTable.ext.errMode = 'throw'
        // Define a custom sorting plugin
        $.fn.dataTable.ext.type.order['formatted-num-asc'] = function (a, b) {
            a = parseFloat(a.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0;
            b = parseFloat(b.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0;
            return a - b;
        }

        $.fn.dataTable.ext.type.order['formatted-num-desc'] = function (a, b) {
            a = parseFloat(a.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0;
            b = parseFloat(b.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0;
            return b - a;
        }

        // Sorting function for dates in 'DD.MM.YYYY' format
        $.fn.dataTable.ext.type.order['moment-date-asc'] = function (a, b) {
            return moment(a, 'DD.MM.YYYY').isAfter(moment(b, 'DD.MM.YYYY')) ? 1 : -1;
        };

        $.fn.dataTable.ext.type.order['moment-date-desc'] = function (a, b) {
            return moment(a, 'DD.MM.YYYY').isBefore(moment(b, 'DD.MM.YYYY')) ? 1 : -1;
        };

        this.extraTable = $('.self-table').DataTable({
            dom: '<ilf<t>p>',
            paging: true,
            info: true,
            searching: false,
            scrollX: true,
            order: [],
            language: {
                lengthMenu: this.$t('datatable.lengthMenu') as string,
                info: this.$t('datatable.info') as string,
                zeroRecords: this.$t('datatable.zeroRecords') as string,
                paginate: {
                    first: this.$t('datatable.first') as string,
                    last: this.$t('datatable.last') as string,
                    next: this.$t('datatable.next') as string,
                    previous: this.$t('datatable.previous') as string
                }

            },
            retrieve: true,
            columnDefs: [
                { type: 'formatted-num', targets: 'sum' },
                {
                    type: 'moment-date',
                    targets: 'date'
                }
            ]
        })

        // Clear the previously appended elements
        const entriesCount = document.querySelector('.self-table-info-entries-count')
        const lengthSelect = document.querySelector('.self-table-info-entries-select')

        if (entriesCount) {
            entriesCount.innerHTML = ''
        }

        if (lengthSelect) {
            lengthSelect.innerHTML = ''
        }

        const tables = document.querySelectorAll('.dataTables_wrapper')

        tables.forEach((table) => {
            const prev = table.previousElementSibling
            const entriesCount = prev.querySelector(
                '.self-table-info-entries-count'
            )
            const lengthSelect = prev.querySelector(
                '.self-table-info-entries-select'
            )

            $(table).find('.dataTables_info').appendTo(entriesCount)
            $(table).find('.dataTables_length').appendTo(lengthSelect)
        })
    }

    // Method to retrieve table data as an object
    private getTableData () {
        const data = this.extraTable.rows().data().toArray();
        const columns = this.extraTable.columns().header().toArray().map(col => col.innerText);

        return data.map(row => {
            const obj = {};
            row.forEach((cell, index) => {
                obj[columns[index]] = cell;
            });
            return obj;
        });
    }

    private destroyExtraTable () {
        if (this.extraTable != null) {
            this.extraTable.destroy()
            this.extraTable = null
        }
    }

    async generateOnClick(InvoiceByDateRequest: IInvoiceByDateRequest) {
        if (this.selectedDateRange.split('—').length !== 2) {
            this.generateReportOk = false
            // if (window.innerWidth < 1024) {
            //     this.scrollToAlertMessage()
            // }
            this.scrollToAlertMessage()
        } else {
            // if (window.innerWidth < 1024) {
            //     this.scrollToResultsTable()
            // }
            this.scrollToResultsTable()
            this.InvoiceByDateRequest.customerid = store.getters.getCustomerId
            this.generateReportOk = true
            this.requestSent = true
            this.initExtraTable = true
            store.commit('setReportInvoiceByDateResponce', null)
            this.destroyExtraTable()
            this.responseReceived = false
            await store.dispatch('getInvoicesByDate', InvoiceByDateRequest)
            this.responseReceived = true
        }
    }

    // Type Declarations for TypeScript to tell that these methods exist in utils.ts
    scrollToAlertMessage!: () => void
    scrollToResultsTable!: () => void
    initDescriptionExpansion!: () => void
    formatDate!: (date: string) => void

    clearAll() {
        this.InvoiceByDateRequest = {
            passenger: {
                passengerId: '',
                name: '',
                birthday: '',
                reference: ''
            } as unknown as IPassenger,
            invoicestartdate: '',
            invoiceenddate: '',
            invoicenumber: '',
            paymentstatus: 'all',
            booking: {
                bookingnumber: '',
                bookedbyname: '',
                customerreference: '',
                projectcode: '',
                employeenumber: '',
                finaccount: '',
                budgetcode: '',
                menumber: ''
            } as unknown as IBooking,
            customerid: store.state.customerId
        }
        this.requestSent = false
        this.$root.$emit('reset-calendar')
        this.selectedDateRange = ''
        this.showOnlyUnpaidInvoices = false
        this.destroyExtraTable()
        this.initExtraTable = true
        this.responseReceived = false
        store.commit('setReportInvoiceByDateResponce', null)
    }

    download(DownloadFileType) {
        const invoices = this.getTableData()
        // Sanitize the data
        const sanitizedInvoices = invoices.map(invoice => {
            const sanitizedInvoice = {};
            for (const key in invoice) {
                if (Object.prototype.hasOwnProperty.call(invoice, key)) {
                    sanitizedInvoice[key] = invoice[key].replace(/<\/?[^>]+(>|$)/g, ""); // remove html tags
                }
            }
            return sanitizedInvoice;
        });

        const data = XLSX.utils.json_to_sheet(sanitizedInvoices)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        if (DownloadFileType === '.xlsx') {
            XLSX.writeFile(wb, 'invoice-report.xlsx')
        } else if (DownloadFileType === '.csv') {
            XLSX.writeFile(wb, 'invoice-report.csv', { bookType: 'csv' })
        }
    }

    // Handling language changes for datatable, toplevels and destination select and countries
    @Watch('$i18n.locale', { immediate: true })
    async onLocaleChange () {
        this.createExtraTable()
        this.initDescriptionExpansion()
    }

    // ============ Lifecycle methods ==========

    mounted (): void {
        this.initDescriptionExpansion()
    }

    updated (): void {
        if (this.InvoiceByDateResponce && this.requestSent && this.initExtraTable) {
            this.createExtraTable()
            this.initExtraTable = false
        }
    }
}
</script>
